import { formatDayString } from "@fullcalendar/core/internal";
import {
  Box,
  Button,
  Card,
  Checkbox,
  Divider,
  Grid,
  Modal,
  Pagination,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { CouponService, GRADE_TYPE, ICoupon, REGION_TYPE } from "service/coupon/service";
import { MemberService } from "service/member/service";

function CouponIssue() {
  const [selectedCoupon, setSelectedCoupon] = useState<ICoupon>(null);
  const [selectedUser, setSelectedUser] = useState<any[]>([]);
  const [couponIssueDate, setCouponIssueDate] = useState<string>(null);
  const [search, setSearch] = useState("");
  const [couponListModalOpen, setCouponListModalOpen] = useState(false);
  const [memberSearchModalOpen, setMemberSearchModalOpen] = useState(false);
  const [couponIssueModalOpen, setCouponIssueModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [checkedUsers, setCheckedUsers] = useState<string[]>([]);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  const handleCheck = (userKey: string) => {
    setCheckedUsers((prev) =>
      prev.includes(userKey) ? prev.filter((e) => e !== userKey) : [...prev, userKey]
    );
  };

  const handleCheckAll = () => {
    if (checkedUsers.length === selectedUser.length) {
      setCheckedUsers([]);
    } else {
      setCheckedUsers(selectedUser.map((user) => user.user_key));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <CouponListModal
        open={couponListModalOpen}
        onClose={() => setCouponListModalOpen(false)}
        setSelectedCoupon={setSelectedCoupon}
      />
      <MemberSearchModal
        open={memberSearchModalOpen}
        onClose={() => setMemberSearchModalOpen(false)}
        search={search}
        setSearch={setSearch}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
      />
      <CouponIssueModal
        open={couponIssueModalOpen}
        onClose={() => setCouponIssueModalOpen(false)}
        coupon={selectedCoupon}
        selectedUser={selectedUser}
        couponIssueDate={couponIssueDate}
        setSelectedCoupon={setSelectedCoupon}
        setSelectedUser={setSelectedUser}
        setCouponIssueDate={setCouponIssueDate}
        setSearch={setSearch}
      />
      <MDBox my={3}>
        <div style={{ fontWeight: "bold", fontSize: 14 }}>지급 쿠폰 선택</div>
        <MDButton
          variant="gradient"
          color={selectedCoupon ? "info" : "secondary"}
          style={{ marginTop: "8px" }}
          onClick={() => setCouponListModalOpen(true)}
        >
          {selectedCoupon
            ? REGION_TYPE[selectedCoupon.region_type as keyof typeof REGION_TYPE] +
              " " +
              GRADE_TYPE[selectedCoupon.grade as keyof typeof GRADE_TYPE] +
              " " +
              selectedCoupon.name
            : "쿠폰 조회"}
        </MDButton>
        <div style={{ fontWeight: "bold", fontSize: 14, marginTop: "16px" }}>지급일 선택</div>
        <TextField
          type="date"
          variant="outlined"
          size="small"
          style={{ width: "200px", marginTop: "8px" }}
          InputLabelProps={{ shrink: true }}
          value={couponIssueDate || ""}
          onChange={(e) => setCouponIssueDate(e.target.value)}
        />
        <div style={{ fontWeight: "bold", fontSize: 14, marginTop: "16px" }}>지급 대상 선택</div>
        <div style={{ marginTop: "8px" }}>
          <input
            type="text"
            placeholder="ID, 회원명, 연락처 등을 입력해주세요."
            style={{
              height: "40px",
              width: "300px",
              padding: "8px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
            value={search}
            onChange={(e: any) => setSearch(e.target.value)}
          />
          <MDButton
            variant="gradient"
            color={selectedUser.length > 0 ? "info" : "secondary"}
            style={{ marginLeft: "8px" }}
            onClick={() => setMemberSearchModalOpen(true)}
          >
            회원검색
          </MDButton>
        </div>
        <div style={{ marginTop: "30px", display: "flex", flexDirection: "column", gap: 8 }}>
          <div style={{ fontWeight: "bold", fontSize: 14, marginBottom: 8 }}>
            쿠폰 지급 확인 목록
          </div>
          <Card style={{ marginTop: "24px" }}>
            <div style={{ padding: "24px 16px" }}>
              <div style={{ overflowX: "auto" }}>
                <div style={{ textAlign: "right" }}>
                  <MDButton
                    onClick={() => {
                      setSelectedUser((prev) =>
                        prev.filter((u) => !checkedUsers.includes(u.user_key))
                      );
                      setCheckedUsers([]);
                    }}
                  >
                    선택 삭제
                  </MDButton>
                </div>
                <table style={{ minWidth: "1000px", width: "100%" }}>
                  <thead>
                    <tr
                      style={{
                        fontSize: "14px",
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "16px",
                        fontFamily: "Pretendard",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <th>idx</th>
                      <th>ID(이메일)</th>
                      <th>회원명</th>
                      <th>연락처</th>
                      <th>지급 쿠폰</th>
                      <th>지급일</th>
                      <th>
                        <input
                          type="checkbox"
                          checked={
                            checkedUsers.length === selectedUser.length && selectedUser.length > 0
                          }
                          onChange={handleCheckAll}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedCoupon && couponIssueDate && selectedUser.length > 0 ? (
                      selectedUser
                        .slice((currentPage - 1) * 10, currentPage * 10)
                        .map((user: any, idx: number) => (
                          <tr
                            key={idx}
                            style={{
                              fontSize: 12,
                              color: "#000000DE",
                              textAlign: "center",
                              fontFamily: "Pretendard",
                            }}
                          >
                            <td style={{ padding: "16px 8px" }}>{idx + (currentPage - 1) * 10}</td>
                            <td style={{ padding: "16px 8px" }}>{user.email}</td>
                            <td style={{ padding: "16px 8px" }}>{user.name}</td>
                            <td style={{ padding: "16px 8px" }}>{user.tel}</td>
                            <td style={{ padding: "16px 8px" }}>{selectedCoupon.name}</td>
                            <td style={{ padding: "16px 8px" }}>{couponIssueDate}</td>
                            <td>
                              <input
                                type="checkbox"
                                checked={checkedUsers.includes(user.user_key)}
                                onChange={() => handleCheck(user.user_key)}
                              />
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td
                          colSpan={6}
                          style={{
                            fontSize: 20,
                            color: "#000000DE",
                            textAlign: "center",
                            fontFamily: "Pretendard",
                          }}
                        >
                          지급할 쿠폰, 지급일, 대상을 선택하고 추가해주세요.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
                <Pagination
                  count={selectedUser.length > 0 ? Math.ceil(selectedUser.length / 10) : 1}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="secondary"
                  sx={{
                    "& .MuiPaginationItem-root": {
                      "&.Mui-selected": {
                        backgroundColor: "#1e9b6b",
                        color: "white",
                      },
                      "&.Mui-selected:hover": {
                        backgroundColor: "#1e9b6b",
                      },
                    },
                  }}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "24px" }}>
                <MDButton
                  variant="contained"
                  color="success"
                  onClick={async () => {
                    if (!selectedCoupon || !couponIssueDate || selectedUser.length === 0) {
                      alert("쿠폰, 지급일, 대상을 모두 선택해주세요.");
                      return;
                    }
                    // 쿠폰 지급 로직 추가
                    // 예시: await CouponService.issueCoupon(selectedCoupon, selectedUser, couponIssueDate);
                    // setSelectedCoupon(null);
                    // setSelectedUser([]);
                    // setCouponIssueDate(null);
                    // alert("쿠폰이 성공적으로 지급되었습니다.");
                    setCouponIssueModalOpen(true);
                  }}
                >
                  쿠폰 지급하기
                </MDButton>
              </div>
            </div>
          </Card>
        </div>
      </MDBox>
    </DashboardLayout>
  );
}

export default CouponIssue;

const CouponListModal = ({ open, onClose, setSelectedCoupon }: any) => {
  const [couponList, setCouponList] = useState<ICoupon[]>([]);
  const [selected, setSelected] = useState<ICoupon>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  const fetchCoupons = async (page: number) => {
    const data = await CouponService.couponList(5, page);
    setCouponList(data.list);
    setTotalPages(Math.ceil(Number(data.totalCount) / 5));
  };

  useEffect(() => {
    if (open) {
      fetchCoupons(1);
    }
  }, [open]);

  useEffect(() => {
    fetchCoupons(currentPage);
  }, [currentPage]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          minWidth: 800,
        }}
      >
        <h4>쿠폰 리스트</h4>
        <Box
          component="table"
          sx={{
            width: 1400,
            borderCollapse: "collapse",
            marginTop: "16px",
            mt: 2,
            border: "1px solid #ddd", // 바깥 테두리
            "& th, & td": { border: "1px solid #ddd", p: 1, textAlign: "center" }, // 셀 테두리
            "& thead th": { bgcolor: "#f5f5f5", fontSize: 14, whiteSpace: "nowrap" },
          }}
        >
          <thead
            style={{
              textAlign: "center",
              backgroundColor: "#f5f5f5",
            }}
          >
            <tr
              style={{
                fontSize: "14px",
                width: "100%",
                fontFamily: "Pretendard",
                whiteSpace: "nowrap",
              }}
            >
              <th style={{ width: 36 }} />
              <th>idx</th>
              <th>쿠폰명</th>
              <th>description</th>
              <th>할인율(할인권)</th>
              <th>쿠폰등록 유효기간</th>
              <th>이용기간(이용권)</th>
              <th>등급(이용권)</th>
              <th>지역(이용권)</th>
              <th>생성일</th>
            </tr>
          </thead>
          <tbody>
            {couponList.map((coupon: ICoupon, idx: number) => (
              <tr
                key={idx}
                style={{
                  fontSize: 12,
                  color: "#000000DE",
                  textAlign: "center",
                  fontFamily: "Pretendard",
                }}
              >
                <td>
                  <Radio
                    size="small"
                    name="coupon-radio"
                    value={coupon.coupon_id}
                    inputProps={{ "aria-label": coupon.name }}
                    checked={selected?.coupon_id === coupon.coupon_id}
                    onChange={() => {
                      setSelected(coupon);
                    }}
                  />
                </td>
                <td>{idx + 1}</td>
                <td>{coupon.name}</td>
                <td>{coupon.description}</td>
                <td>{coupon.discount_value}</td>
                <td>
                  {coupon.valid_from} ~ {coupon.valid_to}
                </td>
                <td>{coupon.use_days}일</td>
                <td>{GRADE_TYPE[coupon.grade as keyof typeof GRADE_TYPE]}</td>
                <td>{REGION_TYPE[coupon.region_type as keyof typeof REGION_TYPE]}</td>
                <td>{coupon.create_time}</td>
              </tr>
            ))}
          </tbody>
        </Box>
        <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="secondary"
            sx={{
              "& .MuiPaginationItem-root": {
                "&.Mui-selected": {
                  backgroundColor: "#1e9b6b",
                  color: "white",
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "#1e9b6b",
                },
              },
            }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "center", marginTop: "16px", gap: "8px" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={onClose}
            style={{ marginTop: "16px", backgroundColor: "#ecececff", color: "black" }}
          >
            닫기
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ marginTop: "16px", backgroundColor: "#6e6e6eff", color: "white" }}
            onClick={() => {
              setSelectedCoupon(selected);
              onClose();
            }}
          >
            선택하기
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

const MemberSearchModal = ({ open, onClose, search, setSearch, setSelectedUser }: any) => {
  const [userList, setUserList] = useState<any[]>([]);
  const [checkedUser, setCheckedUser] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  const toggleUser = (key: any, nextChecked: boolean) => {
    setCheckedUser((prev: any) =>
      nextChecked
        ? [...new Set([...prev, key])]
        : prev.filter((k: any) => k.user_key !== key.user_key)
    );
  };

  const fetchUsers = async (search: string, page: number) => {
    const limit = 5;

    const data = await MemberService.list2(
      "",
      search,
      "",
      "2025-01-01",
      formatDayString(new Date()),
      limit,
      (page - 1) * limit
    );
    setUserList(data.list);
    setTotalPages(data.total_count ? Math.ceil(data.total_count / limit) : 1);
  };

  useEffect(() => {
    if (open) {
      if (!search) {
        setUserList(checkedUser);
      } else {
        fetchUsers(search, currentPage);
      }
    }
  }, [open, currentPage]);

  useEffect(() => {
    if (!search) {
      setUserList(checkedUser);
    }
  }, [search]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          minWidth: 800,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <h4>쿠폰 지급 대상 회원 검색 결과</h4>
        <div style={{ marginTop: "8px" }}>
          <input
            type="text"
            placeholder="ID, 회원명, 연락처 등을 입력해주세요."
            style={{
              height: "40px",
              width: "300px",
              padding: "8px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
            value={search}
            onChange={(e: any) => setSearch(e.target.value)}
          />
          <MDButton
            variant="gradient"
            color="secondary"
            style={{ marginLeft: "8px" }}
            onClick={() => {
              setCurrentPage(1);
              if (!search) {
                setUserList(checkedUser);
              } else {
                fetchUsers(search, 1);
              }
            }}
          >
            회원검색
          </MDButton>
        </div>
        <Box
          component="table"
          sx={{
            width: 800,
            borderCollapse: "collapse",
            marginTop: "16px",
            mt: 2,
            border: "1px solid #ddd", // 바깥 테두리
            "& th, & td": { border: "1px solid #ddd", p: 1, textAlign: "center" }, // 셀 테두리
            "& thead th": { bgcolor: "#f5f5f5", fontSize: 14, whiteSpace: "nowrap" },
          }}
        >
          <thead style={{ textAlign: "center", backgroundColor: "#f5f5f5" }}>
            <tr
              style={{
                fontSize: "14px",
                width: "100%",
                fontFamily: "Pretendard",
                whiteSpace: "nowrap",
              }}
            >
              <th style={{ width: 36 }} />
              <th>ID(이메일)</th>
              <th>회원명</th>
              <th>연락처</th>
              <th>회원등급</th>
              <th>가입일</th>
            </tr>
          </thead>
          <tbody>
            {userList.map((user: any, idx: number) => (
              <tr
                key={idx}
                style={{
                  fontSize: 12,
                  color: "#000000DE",
                  textAlign: "center",
                  fontFamily: "Pretendard",
                }}
              >
                <td>
                  <Checkbox
                    size="small"
                    name="member-radio"
                    checked={checkedUser.some((u: any) => u.user_key === user.user_key)}
                    onChange={(e) => toggleUser(user, e.target.checked)}
                    value={user}
                    inputProps={{ "aria-label": user.email }}
                  />
                </td>
                <td>{user.email}</td>
                <td>{user.name}</td>
                <td>{user.tel}</td>
                <td>{GRADE_TYPE[user.plan_grade as keyof typeof GRADE_TYPE] ?? user.plan_grade}</td>
                <td>{user.created_at}</td>
              </tr>
            ))}
            {userList.length === 0 && (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  데이터 없음
                </td>
              </tr>
            )}
          </tbody>
        </Box>
        <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="secondary"
            sx={{
              "& .MuiPaginationItem-root": {
                "&.Mui-selected": {
                  backgroundColor: "#1e9b6b",
                  color: "white",
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "#1e9b6b",
                },
              },
            }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "center", marginTop: "16px", gap: "8px" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={onClose}
            style={{ backgroundColor: "#ecececff", color: "black", width: "100px" }}
          >
            닫기
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setSelectedUser(checkedUser);
              onClose();
            }}
            style={{ backgroundColor: "#5e5e5eff", color: "white", width: "100px" }}
          >
            선택하기
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

const CouponIssueModal = ({
  open,
  onClose,
  coupon,
  selectedUser,
  couponIssueDate,
  setSelectedCoupon,
  setSelectedUser,
  setCouponIssueDate,
  setSearch,
}: any) => {
  const user = selectedUser[0];
  const handleIssueCoupon = async (couponId: number, userList: string[]) => {
    await CouponService.issueCoupon(couponId, userList);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          minWidth: 800,
        }}
      >
        <Typography variant="h6">쿠폰 지급 확인</Typography>
        <Divider sx={{ my: 2 }} />
        {/* <div>{`${REGION_TYPE[coupon?.region_type as keyof typeof REGION_TYPE]} ${
          GRADE_TYPE[coupon?.grade as keyof typeof GRADE_TYPE]
        } ${coupon?.name}`}</div> */}
        <Box
          sx={{
            border: "1px solid #ddd",
            borderRadius: 2,
            p: 2,
            mb: 2,
          }}
        >
          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
            {`${REGION_TYPE[coupon?.region_type as keyof typeof REGION_TYPE]} 
              ${GRADE_TYPE[coupon?.grade as keyof typeof GRADE_TYPE]} 
              ${coupon?.name}`}
          </Typography>

          {/* 정보표 */}
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <Typography color="text.secondary" fontSize={14}>
                ID(이메일)
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography fontSize={14}>
                {user?.email}
                {selectedUser.length > 1 && ` 외 ${selectedUser.length - 1}명`}
              </Typography>
            </Grid>

            <Grid item xs={4}>
              <Typography color="text.secondary" fontSize={14}>
                회원명
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography fontSize={14}>
                {user?.name}
                {selectedUser.length > 1 && ` 외 ${selectedUser.length - 1}명`}
              </Typography>
            </Grid>

            <Grid item xs={4}>
              <Typography color="text.secondary" fontSize={14}>
                연락처
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography fontSize={14}>
                {user?.tel}
                {selectedUser.length > 1 && ` 외 ${selectedUser.length - 1}개`}
              </Typography>
            </Grid>

            <Grid item xs={4}>
              <Typography color="text.secondary" fontSize={14}>
                지급일
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography fontSize={14}>{couponIssueDate}</Typography>
            </Grid>
          </Grid>
        </Box>

        {/* 버튼 */}
        <Box display="flex" justifyContent="space-between">
          <Button variant="contained" color="error" onClick={onClose}>
            취소
          </Button>
          <Button
            variant="contained"
            color="info"
            onClick={() => {
              handleIssueCoupon(
                coupon.coupon_id,
                selectedUser.map((el: any) => el.user_key)
              ).then(() => {
                alert("쿠폰이 성공적으로 지급되었습니다.");
                setSelectedCoupon(null);
                setSelectedUser([]);
                setCouponIssueDate(null);
                setSearch("");
                onClose();
              });
            }}
          >
            지급하기
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
